import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-content mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-10 rounded-full bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-semibold">
                淇
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-heading text-lg font-semibold text-foreground-950">
                  舒淇 官方网站
                </span>
                <span className="text-[10px] tracking-[0.3em] uppercase text-secondary-500">
                  Shu Qi Official
                </span>
              </div>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md">
              舒淇官网致力于提供舒淇的详细个人资料、丰富影视作品介绍和最新动态资讯，
              满足广大影迷了解作品、追踪动态的需求。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-4">
              网站导航
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="text-foreground-600 hover:text-accent-600 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/works" className="text-foreground-600 hover:text-accent-600 transition-colors">
                  影视作品
                </Link>
              </li>
              <li>
                <Link to="/profile" className="text-foreground-600 hover:text-accent-600 transition-colors">
                  个人资料
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-foreground-600 hover:text-accent-600 transition-colors">
                  新闻资讯
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-4">
              了解更多
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/contact" className="text-foreground-600 hover:text-accent-600 transition-colors">
                  联系与反馈
                </Link>
              </li>
              <li>
                <Link to="/works?type=电影" className="text-foreground-600 hover:text-accent-600 transition-colors">
                  代表作品
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-foreground-600 hover:text-accent-600 transition-colors">
                  最新动态
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 舒淇明星官网 · 本网站内容仅供影迷交流参考
          </p>
          <p className="text-xs text-foreground-500">
            为影迷而建 · Made for fans
          </p>
        </div>
      </div>
    </footer>
  );
}